import * as constans from './constans'
// import axios from 'axios';
// import { fromJS} from 'immutable';
export const getNewsXq = (id)=>({
    type:constans.GETNEWSXQ,
    data:id
})